"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
/**
 * This context is intended to allow information about the current, active
 * layout to be shared across various components at different levels of the tree.
 *
 * Generally speaking a single `<LayoutContext.Provider />` should be used
 * per page. More complex scenarios, however, might necessitate using multiple.
 */
exports.LayoutContext = react_1.default.createContext({
    layoutVariant: 'hcenter',
    currentHeaderHeight: 0,
    setHeaderHeight: function () { }
});
/**
 * A default, stateful wrapper that makes it easy to set the current layout.
 *
 * Most of the time you should use this.
 */
exports.DefaultLayoutProvider = function (_a) {
    var layoutVariant = _a.layoutVariant, children = _a.children;
    var _b = react_1.default.useState(0), currentHeaderHeight = _b[0], setHeaderHeight = _b[1];
    return (react_1.default.createElement(exports.LayoutContext.Provider, { value: {
            layoutVariant: layoutVariant,
            currentHeaderHeight: currentHeaderHeight,
            setHeaderHeight: setHeaderHeight
        } }, children));
};
//# sourceMappingURL=LayoutContext.js.map